import { serialize } from 'cerialize'

export class SceneCreateRequest {
  @serialize name: string;

  constructor(name: string) {
    this.name = name
  }
}